import { render, staticRenderFns } from "./videoCompositing.vue?vue&type=template&id=4f66cc83&scoped=true"
import script from "./videoCompositing.vue?vue&type=script&lang=js"
export * from "./videoCompositing.vue?vue&type=script&lang=js"
import style0 from "./videoCompositing.vue?vue&type=style&index=0&id=4f66cc83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f66cc83",
  null
  
)

export default component.exports